import React, { useEffect, useState } from 'react'
import './OtherProductsInterest.scss'
import { DobleGuion } from './DobleGuion'
import { connect } from 'react-redux'
import { firstCharCapitalize } from '../utils/utils'
import { ArrowIcon } from '../utils/icons'
import * as _ from 'lodash'
import { scrollBodyTop } from '../hooks/scrollPosition'
import { useNavigate } from "react-router-dom"

const OtherProductsInterest = (props) => {
    const { allProducts } = props
    const navigate = useNavigate()
    const [productsInterest, setProductsInterest] = useState([])
    const productsSlider = React.createRef()

    useEffect(() => {
        let products = []
        const productsFilter = _.filter(allProducts, productList => {
            return productList.Forma === props.product.Forma &&
                productList.Diametro.toLowerCase().indexOf('set') === -1 &&
                ((
                    parseInt(productList.Diametro) <= (parseInt(props.product.Diametro) + 7) &&
                    parseInt(productList.Diametro) >= (parseInt(props.product.Diametro) - 7)
                )) &&
                (
                    (productList.UnidadesPack !== '' && productList.UnidadesPack !== '-') ||
                    (productList.UnidadesPallet !== '' && productList.UnidadesPallet !== '-') ||
                    (productList.UVenta2021Suelto !== '' && productList.UVenta2021Suelto !== '-') &&
                    productList.Nombre.toLowerCase().indexOf('expositor') === -1
                )
        })
        for (let i = 0; i < 10; i++) {
            var product = productsFilter[Math.floor(Math.random() * productsFilter.length)];
            if (product !== undefined) {
                products.push(product)
            }
        }
        setProductsInterest(products)
    }, [props.product])

    const handleClickSlidePrev = () => {
        productsSlider.current.scrollLeft = productsSlider.current.scrollLeft - (productsSlider.current.clientWidth)
    }

    const handleClickSlideNext = () => {
        productsSlider.current.scrollLeft = productsSlider.current.scrollLeft + (productsSlider.current.clientWidth)
    }

    const handleClickGoProduct = (url) => {
        scrollBodyTop()
        navigate(url)
    }

    return (
        <div className="other-products-container">
            {productsInterest.length > 0 &&
                <React.Fragment>
                    <div className="title">
                        <p>También puede interesarte:</p>
                        <DobleGuion />
                    </div>
                    <div className="products" ref={productsSlider}>
                        {
                            productsInterest.map((product, index) => {
                                return (
                                    <div key={index} className="product pointer" onClick={() => handleClickGoProduct(`/producto/${product.ID}`)}>
                                        <div className="img">
                                            <img src={"/static/imgProducts/tn_" + product.Fotografia + "_p.jpg"} onError={(e) => {
                                                e.target.onerror = null
                                                e.target.src = '/static/img/no-imagen-fansa.png'
                                            }} alt="" />
                                        </div>
                                        <div className="horizontal-line">
                                            <div className="horizontal-line-content"></div>
                                        </div>
                                        <div className="item-titulo"><p>{product.Categoria}</p></div>
                                        <div className="item-sub-titulo"><p>{firstCharCapitalize(product.Nombre)}</p></div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="buttons">
                        <div className="arrow pointer left-arrow" onClick={handleClickSlidePrev}><ArrowIcon size={13} /></div>
                        <div className="arrow pointer right-arrow" onClick={handleClickSlideNext}><ArrowIcon size={13} /></div>
                    </div>
                </React.Fragment>
            }
        </div>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(OtherProductsInterest)